<template>
  <div v-if="loading" class="base-loader multi"></div>
</template>

<style lang="scss">
.base-loader {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 0.3rem solid rgba(white, 0.3);
  border-top-color: white;
  animation: 1.5s spin infinite linear;

  &.multi {
    border-bottom-color: white;
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>

<script>
export default {
  name: 'BaseLoader',
  props: ['loading']
}
</script>



// WEBPACK FOOTER //
// src/components/Common/BaseLoader.vue